

































































import Vue from "vue";
import DBMenu from "@/components/DBMenu.vue";
  
export default Vue.extend({
  name: "DBProjectSetup",
  components: {
    DBMenu
  }
});
